
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import 'react-medium-image-zoom/dist/styles.css'

import PageHome from "./pages/home";
import ReactGA from 'react-ga';

import {Routes, Route, Link, Navigate} from "react-router-dom";
import BackToTop from "react-back-to-top-button";
import {useTranslation} from "react-i18next";
import React, {useEffect} from "react";
import axios from "axios";
import PageNotFound from "./pages/404";
import PortfolioPage from "./pages/portfolio";
import SinglePortfolioPage from "./pages/portfolio/single";
import SingleServicesPage from "./pages/services/single";
import ServicesPage from "./pages/services";
import PageLayouts from "./components/basic/layouts/page";
import InfoPage from "./pages/info";
import ContactsPage from "./pages/contacts";
import TrackingProjectPage from "./pages/tracking";
import MobileAppPage from "./pages/mobile-app";
import SiteMapPage from "./pages/site-map";
import WorkPage from "./pages/work";
import CookieConsent from "react-cookie-consent";
import ProductsPage from "./pages/products";
import OfferPage from "./pages/form/cooperation";
import DetailTrackingProjectPage from "./pages/tracking/detail";
import PageThankYou from "./pages/form/thank-you";
import AboutPage from "./pages/about";
import WebServicesPage from "./pages/services/web";
import AppServicesPage from "./pages/services/app";
import ScienceWorkPage from "./pages/science-work";
import CertificatesPage from "./pages/certificates";
import LinksPage from "./pages/links";
import DefaultPage from "./pages/default";
import PressPage from "./pages/press";
const TRACKING_ID = "UA-86660902-4"; // OUR_TRACKING_ID
ReactGA.initialize(TRACKING_ID);

function App() {

    const { t, i18n } = useTranslation();

    // useEffect(() => {
    //     axios.post('https://api.lukyanchuk.com/api/v2/frontend/detected', [], {
    //         headers: {
    //             "Content-Type": "application/json",
    //             "Accept": "application/json",
    //         }
    //     }).then((response) => {
    //         console.log(response.data)
    //     });
    //
    // })

    const routesLinks = [
        {
            route: "/about",
            component: <AboutPage/>,
            is_page: false
        },
        {
            route: "/info",
            component: <InfoPage/>,
            is_page: true
        },
        {
            route: "/links",
            component: <InfoPage/>,
            is_page: true
        },
        {
            route: "/contacts",
            component: <ContactsPage/>,
            is_page: false
        },
        {
            route: "/work",
            component: <WorkPage/>,
            is_page: false
        },
        {
            route: "/products",
            component: <ProductsPage/>,
            is_page: false
        },
        {
            route: "/services",
            component: <ServicesPage/>,
            is_page: true
        },
        {
            route: "/work/science-work",
            component: <ScienceWorkPage/>,
            is_page: false
        },
        {
            route: "/about/certificates",
            component: <CertificatesPage/>,
            is_page: false
        },
        {
            route: "/mobile-app",
            component: <MobileAppPage/>,
            is_page: false
        },
        {
            route: "/site-map",
            component: <SiteMapPage/>,
            is_page: true
        },
        {
            route: "/project/tracking",
            component: <TrackingProjectPage/>,
            is_page: false
        },
        {
            route: "/s/mobile-dev",
            component: <AppServicesPage/>,
            is_page: false
        },
        {
            route: "/s/web-dev",
            component: <WebServicesPage/>,
            is_page: false
        },
        {
            route: "/cooperation",
            component: <OfferPage/>,
            is_page: true
        },
        {
            route: "/thank-you",
            component: <PageThankYou/>,
            is_page: true
        },
        {
            route: "/portfolio",
            component: <PortfolioPage type={'default'} />,
            is_page: false
        },
        {
            route: "/projects",
            component: <PortfolioPage type={'default'} />,
            is_page: false
        },
        {
            route: "/links",
            component: <LinksPage />,
            is_page: true
        },
        {
            route: "/bio",
            component: <LinksPage />,
            is_page: true
        },
        {
            route: "/card",
            component: <DefaultPage />,
            is_page: true
        },
        {
            route: "/press",
            component: <PressPage />,
            is_page: true
        },
    ];

    return (
    <div className="App">

        <Routes>

            {/*TODO: add helmet head tags npm*/}

            <Route index exact path={'/'} element={ <PageLayouts child={<PageHome/>} /> }/>

            {
                routesLinks.map((route, key) => <Route key={key} exact path={route.route} element={
                    route.is_page ? route.component : <PageLayouts child={route.component} />
                }/>)
            }

            {/*<Route exact path={'/s/:slug'} element={<PageLayouts child={<SingleServicesPage/>} />}/>*/}

            {/*products pages as portfolio*/}
            {/*<Route exact path={'/portfolio/tag/:name'} element={<PortfolioPage type={'tag'}/>}/>*/}
            {/*<Route exact path={'/portfolio/service/:name'} element={<PortfolioPage type={'service'}/>}/>*/}
            {/*<Route exact path={'/portfolio'} element={<PortfolioPage type={'default'} />}/>*/}

            <Route exact path={'/project/:slug'} element={<SinglePortfolioPage />}/>
            <Route exact path={'/p/:slug'} element={<PageLayouts child={<SinglePortfolioPage/>} />}/>

            <Route path="*" element={<PageLayouts child={<PageNotFound/>} />}/>
        </Routes>

        <BackToTop
            showOnScrollUp
            showAt={100}
            speed={1500}
            easing="easeInOutQuint"
        >
            <div className="button-top d-flex align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="currentColor"
                     className="bi bi-arrow-up" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                          d="M8 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L7.5 2.707V14.5a.5.5 0 0 0 .5.5"/>
                </svg>
                {/*<span className={''}>Top</span>*/}
            </div>
        </BackToTop>

        <CookieConsent
            location="bottom"
            buttonText="OK"
            cookieName="myCookieName"
            expires={150}
            containerClasses="col-lg-12 d-flex align-items-center bg-transparent shadow"
            contentClasses="p-1"
            buttonClasses={"shadow"}
            buttonStyle={{borderRadius: "10px", background: "white", padding: "25px", color: "#1e1e1e"}}
        >
            <div className="p-3 bg-dark border-white rounded-4">
                { t('cookie') }.
                <br/>
                <span>
                    <Link to="/info">{ t('cookie.info') }.</Link>
                </span>
            </div>
        </CookieConsent>
    </div>
  );
}

export default App;
